import React from 'react';
import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner';

export const LoadingPage = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <LoadingSpinner />
    </div>
  );
};
